import PropTypes from 'prop-types';
import React from 'react';
import Field from '../../components/Field';

const CampaignUnsubscribe = ({
  isFetching,
  successMessage,
  errorMessage,
  customerId,
  onSubmit,
  setPhoneValue,
  phone,
}) => (
  <div>
    { !successMessage && !customerId &&
      <form className="layout layout--flush layout--center" onSubmit={onSubmit}>
        <h3 className="c-heading--huge u-text-left u-mt+ u-mb">Please enter your phone number</h3>
        <div className="layout__item u-3/4">
          <Field
            id="phone"
            label="Phone number"
            type="tel"
            placeholder="Enter phone number"
            required
            value={phone}
            onChange={setPhoneValue}
          />
        </div>
        <div className="layout__item u-1/4 u-text-left u-mt--">
          <button className="c-btn c-btn--default u-ph-" disabled={!phone}>Submit</button>
        </div>
      </form>
    }
    { isFetching && <div className="c-heading--large u-mt+">Unsubscribing... Please wait...</div>}
    { !isFetching && errorMessage && <div className="c-heading--large u-co-red u-mt+">{errorMessage}</div>}
    { !isFetching && successMessage && <div className="c-heading--large u-mt+">{successMessage}</div>}
  </div>
);
CampaignUnsubscribe.propTypes = {
  isFetching: PropTypes.bool,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.string,
  customerId: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  setPhoneValue: PropTypes.func.isRequired,
  phone: PropTypes.string,
};
CampaignUnsubscribe.defaultProps = {
  isFetching: false,
  successMessage: '',
  errorMessage: '',
  customerId: '',
  phone: '',
};

export default CampaignUnsubscribe;



// WEBPACK FOOTER //
// ./src/app/confirmation/components/CampaignUnsubscribe.jsx